export const initialState = {}


// WEBPACK FOOTER //
// ./src/interface/store/departments/storage/selectors.js